import React from 'react';
import { PackMeta, SmartActionBtn, SortTh } from './StockPrimitives';

const COLS = 7;

const ProjectedRow = ({ action, openActions, addressedActions, skippedActions, onOpenAction }) => {
  const snap = action.snapshot || {};
  return (
    <tr className="border-b border-border last:border-0 hover:bg-muted/30">
      <td className="py-3 px-4">
        <span className="font-medium">{action.product_name}</span>
      </td>
      <td className="py-3 px-4 text-right text-blue-700 font-medium">
        {snap.wac != null ? `₹${Number(snap.wac).toFixed(2)}` : '—'}
      </td>
      <td className="py-3 px-4 text-right text-emerald-700 font-medium">
        {snap.avg_sell_30d != null ? `₹${Number(snap.avg_sell_30d).toFixed(2)}` : '—'}
      </td>
      <td className="py-3 px-4 text-right text-red-600 font-semibold">
        {snap.loss_per_unit != null ? `₹${Number(snap.loss_per_unit).toFixed(2)}` : '—'}
      </td>
      <td className="py-3 px-4 text-right text-muted-foreground">
        {snap.daily_units != null ? Number(snap.daily_units).toFixed(1) : '—'}
      </td>
      <td className="py-3 px-4 text-right font-bold text-orange-700">
        ₹{Math.round(action.identified_value || 0).toLocaleString('en-IN')}
      </td>
      <td className="py-3 px-4 text-right">
        <SmartActionBtn catalogId={action.catalog_id} productName={action.product_name} openActions={openActions} addressedActions={addressedActions} skippedActions={skippedActions} onOpenAction={onOpenAction} />
      </td>
    </tr>
  );
};


const SectionHeaderRow = ({ label, total, className }) => (
  <tr>
    <td colSpan={COLS - 2} className={`px-4 py-2 text-xs font-semibold uppercase tracking-wide ${className}`}>
      {label}
    </td>
    <td className={`px-4 py-2 text-right font-bold text-sm ${className}`}>
      ₹{Math.round(total).toLocaleString('en-IN')}
    </td>
    <td className={className} />
  </tr>
);

const MarginLeakageTab = ({ leakageToday: _leakageToday, filtered, openActions, addressedActions, skippedActions, onOpenAction, leakageSort, setLeakageSort }) => {
  const projectedActions = [
    ...(openActions      || []),
    ...(addressedActions || []),
    ...(skippedActions   || []),
  ].filter(a => a.type === 'margin_leakage');
  const projectedLoss    = projectedActions.reduce((sum, a) => sum + (a.identified_value || 0), 0);
  const isEmpty          = projectedActions.length === 0;

  const sortRows = (arr, nameKey, lossKey) =>
    [...arr].sort((a, b) => {
      let av, bv;
      switch (leakageSort.col) {
        case 'product_name': av = (a[nameKey] || '').toLowerCase(); bv = (b[nameKey] || '').toLowerCase(); break;
        case 'loss':         av = a[lossKey] ?? -Infinity; bv = b[lossKey] ?? -Infinity; break;
        default:             av = 0; bv = 0;
      }
      if (av < bv) return leakageSort.dir === 'asc' ? -1 : 1;
      if (av > bv) return leakageSort.dir === 'asc' ? 1 : -1;
      return 0;
    });

  const sortedProjected = sortRows(projectedActions, 'product_name', 'identified_value');

  if (isEmpty) {
    return (
      <div className="py-8 text-center text-muted-foreground text-sm">
        No margin leakage detected in the last 30 days.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto w-full">
    <table className="w-full min-w-[560px] text-sm">
      <thead>
        <tr className="border-b border-border text-muted-foreground text-xs uppercase tracking-wide">
          <SortTh col="product_name" label="Product"    sort={leakageSort} setSort={setLeakageSort} />
          <th className="text-right py-3 px-4 whitespace-nowrap">Avg Buy ₹</th>
          <th className="text-right py-3 px-4 whitespace-nowrap">Avg Sell ₹</th>
          <th className="text-right py-3 px-4">Loss / Unit</th>
          <th className="text-right py-3 px-4 whitespace-nowrap">
            Units / Day
            <span className="block text-[10px] normal-case font-normal tracking-normal">30d avg</span>
          </th>
          <SortTh col="loss" label="Loss ₹" sort={leakageSort} setSort={setLeakageSort} right />
          <th className="py-3 px-4" />
        </tr>
      </thead>
      <tbody>
        {projectedActions.length > 0 && (
          <>
            <SectionHeaderRow label="Projected Loss (Next 30 Days)" total={projectedLoss} className="bg-orange-100/40 text-orange-800" />
            {sortedProjected.map((action, i) => (
              <ProjectedRow key={action.id || `p-${i}`} action={action} openActions={openActions} addressedActions={addressedActions} skippedActions={skippedActions} onOpenAction={onOpenAction} />
            ))}
          </>
        )}
      </tbody>
    </table>
    </div>
  );
};

export default MarginLeakageTab;
